module.exports = __webpack_public_path__ + "img/em-pros-04.37ba866a.png";